import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { useSessao } from './sessao.tsx';
import type { Papel } from '../../shared/api/tipos.ts';

/**
 * Porta das rotas internas.
 *
 * Enquanto o token guardado está sendo conferido, mostra espera em vez de
 * mandar para o login: sem isso, cada F5 piscaria a tela de login antes de
 * voltar para onde a pessoa estava.
 *
 * Isto é conveniência de navegação, não segurança — quem recusa o acesso aos
 * dados é o servidor, em cada requisição. Esconder a tela sem proteger a rota
 * da API não protegeria nada.
 */
export function RotaProtegida({ papeis }: { papeis?: readonly Papel[] }) {
  const { usuario, carregando } = useSessao();
  const { pathname } = useLocation();

  if (carregando) {
    return (
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (usuario === null) {
    // `state` guarda onde a pessoa queria chegar, para o login devolver ela ali.
    return <Navigate to="/login" replace state={{ de: pathname }} />;
  }

  if (papeis !== undefined && !papeis.includes(usuario.papel)) {
    // Clientes é a tela que todo papel alcança, e é a inicial de todos.
    return <Navigate to="/clientes" replace />;
  }

  return <Outlet />;
}
